module.exports = __webpack_public_path__ + "img/tweet-content.2e408eae.png";